import * as React from 'react';
import { IconButton } from 'omakase';
import { IconInfoCircle } from '@tock/icons';
import { IconInformation } from 'ui/icons';
import { IconMigrationUtil } from 'omakase/utils/IconMigrationUtil';
import { Popover } from 'ui';
import { Theme, css } from '@emotion/react';

// TODO: remove these !important styles
// We either need a smaller icon button or should
// consider making the receipt a bit less dense because
// the small one doesn't fit at the moment
const receiptLineTooltipIcon = () => css`
  font-size: 1.6rem !important;
`;

const receiptLineTooltipButton = ({ spacing }: Theme) => css`
  margin-left: ${spacing(0.5)}px;
  margin-top: ${spacing(-1)}px;
  margin-bottom: ${spacing(-1)}px;
`;

interface ReceiptLineTooltipProps {
  ariaLabel: string;
  popoverId: string;
  children: React.ReactNode;
  'data-testid'?: string;
}

export const ReceiptLineTooltip: React.FunctionComponent<ReceiptLineTooltipProps> = ({
  ariaLabel,
  popoverId,
  children,
  ...rest
}) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? popoverId : undefined;

  return (
    <>
      <IconButton
        css={receiptLineTooltipButton}
        variant="ghost"
        size="small"
        aria-label={ariaLabel}
        onClick={handleClick}
        data-testid={rest['data-testid'] + '-tooltip'}
      >
        <IconMigrationUtil
          legacyIcon={<IconInformation css={receiptLineTooltipIcon} />}
          newIcon={<IconInfoCircle css={receiptLineTooltipIcon} />}
        />
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        PaperProps={{
          style: { padding: 16, minWidth: '26.8rem' },
        }}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        data-testid={rest['data-testid'] + '-popover'}
      >
        {children}
      </Popover>
    </>
  );
};
